import "./tabs.css";
import { Tab } from "../Tab/Tab";
import { TabButtonRowProps } from "./types";

export const HorizontalTabs = ({
  tabs,
  activeTab,
  setActiveTab,
  isEditMode = false,
  itemTypes = [],
  itemTypesLoading = false,
  onItemTypeSelect,
}: TabButtonRowProps) => {
  return (
    <div className="horizontal-tabs">
      <div className="tab-container">
        {tabs.map((tab) => {
          return (
            <Tab
              key={tab.key}
              label={tab.label}
              isActive={activeTab === tab.key}
              icon={tab.icon}
              onClick={() => setActiveTab(tab.key)}
              isEditMode={isEditMode}
              canAdd={tab.canAdd}
              itemTypes={itemTypes}
              itemTypesLoading={itemTypesLoading}
              onItemTypeSelect={
                onItemTypeSelect
                  ? (itemType) => onItemTypeSelect(itemType, tab.key)
                  : undefined
              }
            />
          );
        })}
      </div>
    </div>
  );
};
